import { z } from 'zod';

export enum TagColorVariant {
  Default = 'DEFAULT',
  Success = 'SUCCESS',
  Warning = 'WARNING',
  Error = 'ERROR',
  Neutral = 'NEUTRAL',
}

export const displayStatusSchema = z.object({
  text: z.string().max(25),
  type: z.enum([
    TagColorVariant.Neutral,
    TagColorVariant.Success,
    TagColorVariant.Warning,
    TagColorVariant.Error,
  ]),
});

export type DisplayStatus = z.infer<typeof displayStatusSchema>;
